module.exports = __webpack_public_path__ + "media/components/src/assets/images/recruits/block_recruit_2-54b215edd781d57807567c16ffef3184.jpg";